import { render, staticRenderFns } from "./positive-form-info.vue?vue&type=template&id=4fb45f0c&scoped=true&"
import script from "./positive-form-info.vue?vue&type=script&lang=js&"
export * from "./positive-form-info.vue?vue&type=script&lang=js&"
import style0 from "./positive-form-info.vue?vue&type=style&index=0&id=4fb45f0c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb45f0c",
  null
  
)

export default component.exports